import type { IProductEntity } from '../models';

import { Transliterate } from '@/shared/helpers';
import { ProductUrl } from './ProductUrl';

export class ProductMM<T extends IProductEntity = IProductEntity> {
  public product: T = {} as T;

  constructor(product?: T) {
    if (product) this.setProduct(product);
  }

  protected setProduct(product: T) {
    this.product = product;
  }

  /** !!! Вернет ссылку на pdp только если есть product.id */
  public getLink(params: Record<string, string> = {}): string {
    if (!this.product?.id) return '';
    if (!this.product?.title) return `/product/${this.product.id}`;

    const url = new ProductUrl(
      `/product/${Transliterate.productTitle(this.product.title)}${this.product.id}`
    );

    url.appendToParams('skuId', this.product.skuId);

    Object.keys(params).forEach((key: string) => {
      url.appendToParams(key, params[key]);
    });

    return url.getUrl();
  }

  /**
   * возможно, класс ProductMM неудобен, можно ограничиться только IProductEntity,
   * перейти от ООП -> ФП (хелперы)
   */
  static getLink(product: IProductEntity, params: Record<string, string> = {}): string {
    if (!product?.id) return '';
    if (!product?.title) return `/product/${product.id}`;

    const url = new ProductUrl(
      `/product/${Transliterate.productTitle(product.title)}${product.id}`
    );

    url.appendToParams('skuId', product.skuId);

    Object.keys(params).forEach((key: string) => {
      url.appendToParams(key, params[key]);
    });

    return url.getUrl();
  }
}
